module.exports = __webpack_public_path__ + "static/media/instagram.0e6033f7.svg";